import React from "react";
import { Pick5 } from "./Pick5";
import { BackButton } from "../NavButton";

export const Skajillion = ({ active, getSlideNumber, updateActiveSlide }) => {
  return (
    <div id="skajillion" className={`${active ? "active " : ""}item`}>
      <div
        className="fill center-always"
        style={{
          backgroundPosition: "inherit",
          backgroundImage: "url('/images/full_page/skajillion.jpg')",
        }}
      >
        <div className="container text-center white-text helvetica-light">
          <img
            src="/images/skajillion-logo-head_white.png"
            style={{ width: "50%", height: "auto" }}
            alt="Skajillion"
          />
          <p>It's not how many you catch it's how many you keep.</p>
          <br />
          <br />
          <BackButton onClick={() => updateActiveSlide(getSlideNumber(Pick5))} />
        </div>
      </div>
    </div>
  );
};
Skajillion.slideName = "Skajillion";
Skajillion.pathname = "/skajillion";
